import { useWatch } from "react-hook-form";

import { useBulkEditFormContext, useCrudEditContext } from "@ryde/redux";
import {
  BookingFormFields,
  DROPDOWN_BOUND_QUICK_ADD_STATION_ALLOWED_LIST,
  getBookingHomeStationFieldName,
  useHasPermissions,
  type IExtendableDto,
} from "@ryde/shared";

import type { IUseCanQuickAddStation } from "./quick-add-station-form.models";

export const useCanQuickAddStation = ({
  name,
  dropItemsSource,
  suffixToEntity,
}: IUseCanQuickAddStation): boolean => {
  const { entity } = useCrudEditContext<IExtendableDto>();
  const { isBulkEditForm } = useBulkEditFormContext();
  const direction = useWatch({ name: BookingFormFields.direction });

  const { hasPermissions } = useHasPermissions({
    entity: dropItemsSource || "unknown",
    action: "create",
  });

  // Bulk edit spans bookings of both directions, so no field there is reliably the home side.
  const isBookingHomeStationField =
    entity === "booking" &&
    !isBulkEditForm &&
    name === getBookingHomeStationFieldName(direction);

  return (
    hasPermissions &&
    (DROPDOWN_BOUND_QUICK_ADD_STATION_ALLOWED_LIST.includes(suffixToEntity) ||
      isBookingHomeStationField)
  );
};
